import {
    useFloatingToolbar,
    useFloatingToolbarState,
    offset,
    flip,
} from '@platejs/floating';
import { useComposedRef } from '@udecode/cn';
import {
    useEditorId,
    useEventEditorValue,
    usePluginOption,
} from "platejs/react";
import styles from '../styles/SlateEditor.module.scss';
import {NodeType} from "../utils";

export function FloatingToolbar({
    children,
    ...props
                                }) {
    const editorId = useEditorId();
    const focusedEditorId = useEventEditorValue('focus');
    const isFloatingLinkOpen = !!usePluginOption({ key: NodeType.LINK }, 'mode');

    const floatingToolbarState = useFloatingToolbarState({
        editorId,
        focusedEditorId,
        hideToolbar: isFloatingLinkOpen,
        floatingOptions: {
            // https://github.com/udecode/plate/issues/4569
            // https://github.com/udecode/plate/discussions/4570
            // https://github.com/udecode/plate/discussions/4504
            // I followed all the debugging steps suggested, but could not fix the issue
            // Overriding the getBoundingClientRect function works
            getBoundingClientRect: () => {
                const selection = window.getSelection();
                if (!selection || selection.rangeCount === 0) {
                    return {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    };
                }
                const range = selection.getRangeAt(0);
                return range.getBoundingClientRect();
            },
            middleware: [
                offset(12),
                flip({
                    fallbackPlacements: [
                        'top-start',
                        'top-end',
                        'bottom-start',
                        'bottom-end',
                    ],
                    padding: 12,
                }),
            ],
            placement: 'top',
        },
    });

    const {
        clickOutsideRef,
        hidden,
        props: rootProps,
        ref: floatingRef,
    } = useFloatingToolbar(floatingToolbarState);

    const ref = useComposedRef<HTMLDivElement>(props.ref, floatingRef);

    if (hidden) return null;

    return (
        <div ref={clickOutsideRef}>
            <div
                ref={ref}
                className={styles.floatingToolbar}
                {...props}
                {...rootProps}
            >
                {children}
            </div>
        </div>
    );
}
